import Vue from 'vue'
import App from './App.vue'

import VueHighcharts from 'highcharts-vue'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(VueHighcharts)

new Vue({
  render: h => h(App),
}).$mount('#app')
